import $ from 'jquery'

// Site-wide widget initialization that used to live inline in the old
// app/javascript/packs/application.js (owl carousel, magnific popup
// galleries, tooltips, header toggle). Dropped during the Vite migration
// and restored here so the vendored plugin files (carousel.js, popup.js)
// actually get wired up to the page.

const spriteLink = document.head.querySelector('link[rel="sprite"]')

const navText = spriteLink
  ? [
      '<svg class="icon"><use xlink:href="' + spriteLink.href + '?#ap"></use></svg>',
      '<svg class="icon"><use xlink:href="' + spriteLink.href + '?#an"></use></svg>',
    ]
  : []

$(function () {
  $('a.disabled').click(function (e) {
    e.preventDefault()
    return false
  })

  $('.message__close').click(function (e) {
    $(this).closest('.message').fadeOut(250)
  })

  $('.btn-response').click(function (e) {
    $('#newRequest').attr('action', '/announcements/' + $(this).data('id') + '/send_response')
  })

  $('.header .toggle').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active')
      $('.header__content').removeClass('show')
    } else {
      $(this).addClass('active')
      $('.header__content').addClass('show')
    }
  })

  $('.header .toggle').blur(function () {
    if ($(this).hasClass('active')) {
      setTimeout(() => {
        $(this).removeClass('active')
        $('.header__content').removeClass('show')
      }, 250)
    }
  })

  $('[data-toggle="tooltip"]').tooltip({
    html: true,
  })

  $('[data-show="popup"]').magnificPopup({
    type: 'inline',
    fixedContentPos: true,
    fixedBgPos: true,
  })

  $('[data-large]').magnificPopup({
    type: 'image',
    fixedContentPos: true,
    fixedBgPos: true,
    image: {
      titleSrc: function (item) {
        return item.el.data('name') + '<small>' + item.el.data('small') + '</small>'
      },
    },
    zoom: { enabled: true },
    callbacks: {
      elementParse: function (item) {
        item.src = item.el.data('large')
      },
    },
  })

  $('.cabinet__img').each(function () {
    const el = $(this)
    const id = `#${el.attr('id')}`
    const items = el.data('images').map((el) => ({ src: el }))

    $(id).magnificPopup({
      type: 'image',
      fixedContentPos: true,
      fixedBgPos: true,
      gallery: { enabled: true, tCounter: '' },
      items: items,
    })
  })

  $('[data-master]').magnificPopup({
    type: 'image',
    fixedContentPos: true,
    fixedBgPos: true,
    gallery: { enabled: true, tCounter: '' },
    image: {
      tError: '<a href="%url%">Фото #%curr%</a> не загружено.',
      titleSrc: function (item) {
        return item.el.data('name') + '<small>' + item.el.data('small') + '</small>'
      },
    },
    zoom: { enabled: true },
    callbacks: {
      elementParse: function (item) {
        item.src = item.el.data('master')
      },
      open: function () {
        const mp = $.magnificPopup.instance
        const t = $(mp.currItem.el[0])

        $.ajax({
          type: 'GET',
          url: '/masters/' + t.data('id') + '/increment_view',
        })
      },
    },
  })

  $('#gallery').magnificPopup({
    delegate: 'a.item',
    type: 'image',
    fixedContentPos: true,
    fixedBgPos: true,
    gallery: { enabled: true, tCounter: '' },
    image: {
      tError: '<a href="%url%">Фото #%curr%</a> не загружено.',
      titleSrc: function (item) {
        return item.el.data('name') + '<small>' + item.el.data('small') + '</small>'
      },
    },
    zoom: { enabled: true },
  })

  $('.master__gallery').magnificPopup({
    delegate: 'a.item',
    type: 'image',
    fixedContentPos: true,
    fixedBgPos: true,
    gallery: { enabled: true, tCounter: '' },
    image: {
      tError: '<a href="%url%">Фото #%curr%</a> не загружено.',
      titleSrc: function (item) {
        return item.el.data('name') + '<small>' + item.el.data('small') + '</small>'
      },
    },
    zoom: { enabled: true },
  })

  $('.welcome__carousel')
    .on('initialized.owl.carousel changed.owl.carousel', function (e) {
      if (!e.namespace) {
        return
      }
      $('#counter').text(e.relatedTarget.relative(e.item.index) + 1 + '/' + e.item.count)
    })
    .owlCarousel({
      items: 1,
      margin: 50,
      smartSpeed: 700,
      loop: true,
      autoplay: true,
      autoplayTimeout: 10000,
      autoplayHoverPause: true,
      nav: true,
      dots: true,
      navText,
    })

  $('.welcome__carousel2').owlCarousel({
    items: 1,
    margin: 50,
    smartSpeed: 700,
    loop: true,
    autoplay: true,
    autoplayTimeout: 10000,
    autoplayHoverPause: true,
    nav: true,
    dots: true,
    navText,
  })

  $('.master__gallery2 .owl-carousel').owlCarousel({
    items: 1,
    margin: 20,
    loop: true,
    nav: true,
    dots: false,
    navText,
  })

  // master gallery (main image synced with thumbnail strip)
  const bigimage = $('.master__gallery #preview')
  const thumbs = $('.master__gallery #thumbs')
  const syncedSecondary = true

  bigimage
    .owlCarousel({
      items: 1,
      slideSpeed: 2000,
      autoplay: true,
      dots: false,
      nav: true,
      navText,
      loop: true,
    })
    .on('changed.owl.carousel', syncPosition)

  thumbs
    .on('initialized.owl.carousel', function () {
      thumbs.find('.owl-item').eq(0).addClass('current')
    })
    .owlCarousel({
      items: 4,
      dots: false,
      nav: false,
      margin: 10,
    })
    .on('changed.owl.carousel', syncPosition2)

  function syncPosition(el) {
    const count = el.item.count - 1
    let current = Math.round(el.item.index - el.item.count / 2 - 0.5)

    if (current < 0) {
      current = count
    }
    if (current > count) {
      current = 0
    }

    thumbs.find('.owl-item').removeClass('current').eq(current).addClass('current')
    const onscreen = thumbs.find('.owl-item.active').length - 1
    const start = thumbs.find('.owl-item.active').first().index()
    const end = thumbs.find('.owl-item.active').last().index()

    if (current > end) {
      thumbs.data('owl.carousel').to(current, 100, true)
    }
    if (current < start) {
      thumbs.data('owl.carousel').to(current - onscreen, 100, true)
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      const number = el.item.index
      bigimage.data('owl.carousel').to(number, 100, true)
    }
  }

  thumbs.on('click', '.owl-item', function (e) {
    e.preventDefault()
    const number = $(this).index()
    bigimage.data('owl.carousel').to(number, 300, true)
  })
})
